import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useAppBrandKitContext } from '@/context/AppBrandKitContext'
import { useBuilderColorSchemeV2 } from '@/hooks/__project__/useBuilderColorSchemeV2'

import { CompDividerWrapperCore } from '../core/divider/wrapper'

/**
 * CompDividerWrapper
 */
const CompDividerWrapper = () => {
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useCompBackgroundColor()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  return <CompDividerWrapperCore infos={infosProps} />
}


export default CompDividerWrapper